import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Truck } from "lucide-react";

const MD = {
  h2: ({ node, ...p }) => <h2 className="font-heading text-xl sm:text-2xl font-black tracking-tight text-slate-900 mt-10 mb-3" {...p} />,
  h3: ({ node, ...p }) => <h3 className="font-heading text-lg font-bold text-slate-900 mt-6 mb-2" {...p} />,
  p: ({ node, ...p }) => <p className="text-slate-600 text-[15px] leading-relaxed my-3" {...p} />,
  ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1.5 text-slate-600 text-[15px] leading-relaxed my-3" {...p} />,
  ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1.5 text-slate-600 text-[15px] leading-relaxed my-3" {...p} />,
  li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
  a: ({ node, ...p }) => <a className="text-emerald-700 font-semibold underline hover:text-emerald-600" {...p} />,
  strong: ({ node, ...p }) => <strong className="font-semibold text-slate-800" {...p} />,
  hr: () => <hr className="my-8 border-slate-200" />,
  table: ({ node, ...p }) => (
    <div className="my-5 overflow-x-auto">
      <table className="w-full text-[14px] border border-slate-200 rounded-lg overflow-hidden" {...p} />
    </div>
  ),
  thead: ({ node, ...p }) => <thead className="bg-slate-100" {...p} />,
  th: ({ node, ...p }) => <th className="text-left font-semibold text-slate-700 px-4 py-2.5 border-b border-slate-200 align-top" {...p} />,
  td: ({ node, ...p }) => <td className="text-slate-600 px-4 py-2.5 border-b border-slate-100 align-top" {...p} />,
};

export default function LegalPage({ title, lastUpdated, body, testid }) {
  const loggedIn = !!localStorage.getItem("token");
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testid}>
      <header className="bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <Truck size={24} />
            <span className="font-heading font-black text-lg tracking-tight">HAULCHECK</span>
          </Link>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-sm font-semibold text-slate-300 hover:text-white">Privacy</Link>
            <Link to="/dpa" className="text-sm font-semibold text-slate-300 hover:text-white">DPA</Link>
            <Link to={loggedIn ? "/dashboard" : "/login"} className="text-sm font-semibold text-slate-200 hover:text-white">
              {loggedIn ? "Back to app" : "Sign in"}
            </Link>
          </div>
        </div>
      </header>

      <section className="bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-6 pb-12 pt-4">
          <p className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-semibold">Legal</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight mt-3">{title}</h1>
          {lastUpdated && <p className="mt-3 text-slate-400 text-sm">Last updated: {lastUpdated}</p>}
        </div>
      </section>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-10 shadow-sm">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD}>{body}</ReactMarkdown>
        </div>
      </main>

      <footer className="border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-sm text-slate-400">
          <span className="flex items-center gap-2 font-heading font-bold text-slate-500"><Truck size={16} /> HAULCHECK</span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-slate-700">Privacy Policy</Link>
            <Link to="/dpa" className="hover:text-slate-700">DPA</Link>
            <Link to="/contact" className="hover:text-slate-700">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
